/* FitMedix theme — progressive enhancement only.
   Everything here is optional: the pages work without JavaScript. */
(function () {
  'use strict';

  /* ---------- header: mobile drawer + search toggle ----------
     The drawer, scrim and searchbar are shown by toggling `.open`, which is
     the class base.css keys off. */
  var mnav = document.querySelector('[data-mnav]');
  var scrim = document.querySelector('[data-close-all]');
  var searchbar = document.querySelector('[data-searchbar]');

  var cartDrawer = document.querySelector('[data-cart-drawer]');

  /* ---------- PDP discount banner: copy code ---------- */
  var pdpPromoCopy = document.querySelector('[data-pdp-promo-copy]');
  if (pdpPromoCopy) {
    pdpPromoCopy.addEventListener('click', function () {
      var code = pdpPromoCopy.getAttribute('data-code') || '';
      if (navigator.clipboard) navigator.clipboard.writeText(code);
      pdpPromoCopy.classList.add('copied');
      setTimeout(function () { pdpPromoCopy.classList.remove('copied'); }, 1500);
    });
  }

  /* ---------- announcement bar: mobile marquee ----------
     Below 620px there isn't room to show every item side by side, so
     instead of hiding all but the first (the old behaviour — free
     delivery/returns/etc. were simply invisible on mobile), duplicate the
     track once and scroll it in a seamless loop so everything stays
     reachable. Skipped entirely under prefers-reduced-motion via CSS. */
  var announceScroll = document.querySelector('[data-announce-scroll]');
  if (announceScroll && window.matchMedia('(max-width: 620px)').matches) {
    var track = announceScroll.querySelector('.announce-track');
    if (track && track.children.length) {
      var inner = document.createElement('div');
      inner.className = 'announce-marquee';
      announceScroll.appendChild(inner);
      inner.appendChild(track);
      var clone = track.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      inner.appendChild(clone);
      announceScroll.classList.add('is-marquee');
    }
  }

  /* ---------- sticky announcement + header stacking (mobile) ----------
     Both bars use position:sticky (CSS, mobile-only); the header's top
     offset must equal the announcement bar's real rendered height so they
     stack without a gap or overlap while scrolling. Measured live rather
     than hardcoded since marquee/wrap height can vary by content. */
  var announceEl = document.querySelector('.announce');
  function setAnnounceHeightVar() {
    if (!announceEl) return;
    document.documentElement.style.setProperty('--announce-h', announceEl.getBoundingClientRect().height + 'px');
  }
  setAnnounceHeightVar();
  window.addEventListener('resize', setAnnounceHeightVar);
  if (window.ResizeObserver && announceEl) {
    new ResizeObserver(setAnnounceHeightVar).observe(announceEl);
  }

  function closeAll() {
    if (mnav) mnav.classList.remove('open');
    if (searchbar) searchbar.classList.remove('open');
    if (cartDrawer) { cartDrawer.classList.remove('open'); cartDrawer.setAttribute('aria-hidden', 'true'); }
    if (scrim) scrim.hidden = true;
    document.body.classList.remove('nav-open');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-toggle-mnav]')) {
      if (mnav) mnav.classList.add('open');
      if (scrim) scrim.hidden = false;
      document.body.classList.add('nav-open');
      return;
    }
    if (e.target.closest('[data-toggle-search]')) {
      if (searchbar) {
        var open = searchbar.classList.toggle('open');
        if (open) { var i = searchbar.querySelector('input'); if (i) i.focus(); }
      }
      return;
    }
    if (e.target.closest('[data-close-all]')) { closeAll(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  /* ---------- collection filter chips ----------
     Chips are real links, so this only smooths the interaction; without JS
     they still navigate to the collection. */
  var chips = document.querySelector('[data-chiprow]');
  if (chips) {
    chips.addEventListener('click', function (e) {
      var c = e.target.closest('.chip');
      if (!c) return;
      chips.querySelectorAll('.chip').forEach(function (x) { x.classList.remove('active'); });
      c.classList.add('active');
    });
  }

  /* ---------- guides: search + category filter ----------
     Filters cards already on the page. Pagination is server-side, so this
     narrows the current page only; the category chips are links that re-query. */
  var q = document.querySelector('[data-guide-search]');
  if (q) {
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-guide]'));
    var count = document.querySelector('[data-guide-count]');
    q.addEventListener('input', function () {
      var term = q.value.trim().toLowerCase();
      var shown = 0;
      cards.forEach(function (card) {
        var hay = (card.getAttribute('data-guide') || '').toLowerCase();
        var hit = !term || term.split(/\s+/).every(function (w) { return hay.indexOf(w) > -1; });
        card.hidden = !hit;
        if (hit) shown++;
      });
      if (count) count.textContent = shown + (shown === 1 ? ' guide' : ' guides');
    });
  }

  /* Product-page quantity stepper is handled by the inline script in
     main-product.liquid (it keeps price, tiles and quantity in sync). */

  /* ---------- trade range: category filter + add-to-quote ----------
     Both are enhancements: without JS every card is visible and the
     application form is still there to fill in by hand. */
  var tf = document.querySelector('[data-trade-filters]');
  var tg = document.querySelector('[data-trade-grid]');
  if (tf && tg) {
    tf.addEventListener('click', function (e) {
      var b = e.target.closest('.t-filter');
      if (!b) return;
      var cat = b.getAttribute('data-cat');
      tf.querySelectorAll('.t-filter').forEach(function (x) {
        x.setAttribute('aria-pressed', String(x === b));
      });
      tg.querySelectorAll('.t-prod').forEach(function (c) {
        c.classList.toggle('is-hidden', cat !== 'all' && c.getAttribute('data-cat') !== cat);
      });
    });

    tg.addEventListener('click', function (e) {
      var b = e.target.closest('.t-addbtn');
      if (!b) return;
      var box = document.querySelector('.t-form textarea');
      if (box) {
        box.value = (box.value ? box.value.replace(/\s+$/, '') + '\n' : '') + b.getAttribute('data-q');
        box.focus();
      }
      var apply = document.getElementById('apply');
      if (apply) apply.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ---------- product gallery: thumbnail + dot switching ---------- */
  var gMain = document.querySelector('[data-g-main]');
  if (gMain) {
    /* Cap the thumbnail rail to the main image's real rendered height
       (--g-main-h, aspect-ratio:1/1 so it changes with viewport width) so
       it scrolls instead of running straight down past the photo. */
    var galleryRoot = gMain.closest('.gallery') || document.documentElement;
    function setGMainHeightVar() {
      galleryRoot.style.setProperty('--g-main-h', gMain.getBoundingClientRect().height + 'px');
    }
    setGMainHeightVar();
    window.addEventListener('resize', setGMainHeightVar);
    if (window.ResizeObserver) { new ResizeObserver(setGMainHeightVar).observe(gMain); }

    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-g-rail] .g-thumb'));
    var dots = Array.prototype.slice.call(document.querySelectorAll('[data-g-dots] .dot'));
    var srcs = thumbs.map(function (t) { return t.getAttribute('data-full'); });
    var count = srcs.length;
    var cur = 0;
    function show(i) {
      i = Math.max(0, Math.min(count - 1, i));
      cur = i;
      var main = gMain.querySelector('img');
      if (main && srcs[i]) {
        /* clear srcset first, or the browser keeps showing the old image */
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.setAttribute('src', srcs[i]);
      }
      thumbs.forEach(function (t, ti) { t.classList.toggle('active', ti === i); });
      dots.forEach(function (d, di) { d.classList.toggle('active', di === i); });
    }
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-g-rail] .g-thumb');
      if (t) { show(parseInt(t.getAttribute('data-i'), 10)); return; }
      var d = e.target.closest('[data-g-dots] .dot');
      if (d) { show(parseInt(d.getAttribute('data-i'), 10)); }
    });

    /* swipe on the main image (mobile) */
    if (count > 1) {
      var startX = null, startY = null;
      gMain.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX; startY = e.touches[0].clientY;
      }, { passive: true });
      gMain.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        /* horizontal swipe only, ignore vertical scrolls */
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          show(dx < 0 ? cur + 1 : cur - 1);
        }
        startX = null; startY = null;
      }, { passive: true });
    }
  }

  /* ---------- best-sellers carousel: prev / next scroll ---------- */
  var carousel = document.querySelector('[data-carousel]');
  if (carousel) {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-car]');
      if (!b) return;
      var card = carousel.querySelector('.prod-card');
      var step = card ? card.getBoundingClientRect().width + 18 : 300;
      carousel.scrollBy({ left: b.getAttribute('data-car') === 'next' ? step : -step, behavior: 'smooth' });
    });
  }

  /* ---------- product accordion panels (mobile) ----------
     Desktop shows every panel open; below the breakpoint the header toggles. */
  var panels = document.querySelector('[data-panels]');
  if (panels) {
    panels.addEventListener('click', function (e) {
      if (window.matchMedia('(min-width: 861px)').matches) return;
      var head = e.target.closest('.panel-head');
      if (!head) return;
      var panel = head.closest('.panel');
      var open = panel.classList.toggle('open');
      head.setAttribute('aria-expanded', String(open));
    });
  }

  /* ---------- product: Buy Now (add current selection, go to checkout) ---------- */
  var buyNow = document.querySelector('[data-buy-now]');
  if (buyNow) {
    buyNow.addEventListener('click', function () {
      var qtyInput = document.querySelector('[data-qty-input]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      buyNow.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: buyNow.getAttribute('data-variant'), quantity: qty })
      }).then(function () { window.location.href = '/checkout'; })
        .catch(function () { buyNow.disabled = false; });
    });
  }

  /* ---------- product card: quantity steppers (delegated) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-card-qty] button[data-qs]');
    if (!btn) return;
    var box = btn.closest('[data-card-qty]');
    var valEl = box.querySelector('[data-qs-val]');
    var form = btn.closest('form');
    var input = form ? form.querySelector('[data-card-qtyinput]') : null;
    var next = Math.max(1, (parseInt(valEl.textContent, 10) || 1) + parseInt(btn.getAttribute('data-qs'), 10));
    valEl.textContent = next;
    if (input) input.value = next;
  });

  /* ---------- slide-out cart drawer + AJAX add-to-cart ----------
     Clicking any product add-to-cart adds via /cart/add.js, then the drawer
     opens showing the cart with an "Added to Cart" green-tick confirmation.
     Everything degrades gracefully: without JS the forms post normally. */
  if (cartDrawer) {
    var body = cartDrawer.querySelector('[data-cart-body]');
    var foot = cartDrawer.querySelector('[data-cart-foot]');
    var totalEl = cartDrawer.querySelector('[data-cart-total]');
    var shipEl = cartDrawer.querySelector('[data-cart-ship]');
    var addedEl = cartDrawer.querySelector('[data-cart-added]');
    var addedTimer;
    var FREE_THRESHOLD = 1500;   /* pence — matches cart.liquid's free_threshold */

    function money(cents) { return '£' + (cents / 100).toFixed(2); }

    /* Same free-delivery progress bar as the basket page, kept in sync here
       so it updates live as items are added/removed without a page reload. */
    function renderShip(totalPrice) {
      if (!shipEl) return;
      if (totalPrice < FREE_THRESHOLD) {
        var remaining = FREE_THRESHOLD - totalPrice;
        var pct = Math.floor((totalPrice * 100) / FREE_THRESHOLD);
        shipEl.innerHTML = '<div class="cart-ship">' +
          '<p>Add <strong>' + money(remaining) + '</strong> for <strong>free UK delivery</strong>.</p>' +
          '<div class="cart-bar"><span style="width:' + pct + '%"></span></div></div>';
      } else {
        shipEl.innerHTML = '<div class="cart-ship cart-ship--won">' +
          '<p><strong>You’ve unlocked free UK delivery.</strong></p>' +
          '<div class="cart-bar"><span style="width:100%"></span></div></div>';
      }
    }

    function openCart() {
      cartDrawer.classList.add('open');
      cartDrawer.setAttribute('aria-hidden', 'false');
      if (scrim) scrim.hidden = false;
    }

    function showAdded() {
      if (!addedEl) return;
      addedEl.hidden = false;
      clearTimeout(addedTimer);
      addedTimer = setTimeout(function () { addedEl.hidden = true; }, 2600);
    }

    function setCount(n) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = n;
        if (n > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
      });
    }

    /* Case/carton lines from the Bulk Buy page (tagged with the `_bulk`
       property) are a fixed size: no stepper, just what it is and a remove
       button. The discount Function only honours the bulk rate on whole
       cases/cartons, so letting the quantity drift would silently lose it. */
    function lineControls(it) {
      if (it.properties && it.properties._gift) {
        return '<div class="cl-gift">Free gift</div>';
      }
      var tier = it.properties && it.properties._bulk;
      if (tier) {
        var size = tier === 'carton' ? 'Carton' : 'Case';
        return '<div class="cl-bulk"><span>' + size + ' &middot; ' + it.quantity + ' packs</span>' +
          '<button type="button" class="cl-remove" data-line-remove>Remove</button></div>';
      }
      return '<div class="qty" data-line-qty>' +
        '<button type="button" data-line-step="-1" aria-label="Decrease">&minus;</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button type="button" data-line-step="1" aria-label="Increase">+</button></div>';
    }

    function render(cart) {
      setCount(cart.item_count);
      if (totalEl) totalEl.textContent = money(cart.total_price);
      renderShip(cart.total_price);
      if (!cart.items || !cart.items.length) {
        if (body) body.innerHTML = '<div class="cart-empty">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M2.6 3.4h2.6l2.4 11.4h9.6l2.2-8H6.4"/><circle cx="9.4" cy="19.4" r="1.6"/><circle cx="16.6" cy="19.4" r="1.6"/></svg>' +
          '<p>Your cart is empty.</p><a class="btn btn--ghost btn--sm" href="/collections/all">Start shopping</a></div>';
        if (foot) foot.hidden = true;
        return;
      }
      if (foot) foot.hidden = false;
      if (body) {
        body.innerHTML = cart.items.map(function (it) {
          var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') + '" alt="" loading="lazy">' : '';
          var saved = it.original_line_price > it.final_line_price
            ? '<span class="cl-save">&minus;' + money(it.original_line_price - it.final_line_price) + '</span>' : '';
          var variant = it.variant_title && it.variant_title !== 'Default Title'
            ? '<span class="cl-m">' + it.variant_title + '</span>' : '';
          return '<div class="cart-line" data-key="' + it.key + '">' +
            '<a class="cl-i" href="' + it.url + '">' + img + '</a>' +
            '<div class="cl-mid"><a class="cl-t" href="' + it.url + '">' + it.product_title + '</a>' + variant +
              lineControls(it) + '</div>' +
            '<div class="cl-r"><span class="price">' + money(it.final_line_price) + '</span>' + saved + '</div>' +
          '</div>';
        }).join('');
      }
    }

    /* ---------- free-gift trial (8x10cm dressing only) ----------
       Buy 3 packs and the zinc oxide tape is free; buy 6 and the gauze
       swabs come too. The gift goes in as an ordinary line carrying a
       `_gift` property, and the multibuy-discount Function is what makes
       it £0 -- it only does that when the qualifying packs are really
       there, so a stale gift line can never be given away by mistake.
       This keeps the lines in step after every cart change: it adds what
       has been earned and removes what hasn't. The variant IDs and the
       3/6 thresholds must match GIFT_QUALIFIER in
       cart_lines_discounts_generate_run.js and the tiles in
       sections/main-product.liquid. */
    var GIFT_QUALIFIER = 54832092250451;   /* 8x10cm dressing */
    var GIFT_TAPE = 54832093069651;        /* zinc oxide tape */
    var GIFT_GAUZE = 54832092905811;       /* gauze swabs 5x5cm */

    function giftsEarned(qty) {
      if (qty >= 6) return [GIFT_TAPE, GIFT_GAUZE];
      if (qty >= 3) return [GIFT_TAPE];
      return [];
    }

    function reconcileGifts(cart) {
      if (!cart || !cart.items) return Promise.resolve(cart);
      var qualifying = 0;
      var present = {};
      cart.items.forEach(function (it) {
        var isGift = it.properties && it.properties._gift;
        if (isGift) { present[it.variant_id] = it; return; }
        if (it.variant_id === GIFT_QUALIFIER) qualifying += it.quantity;
      });
      var earned = giftsEarned(qualifying);
      var jobs = [];

      earned.forEach(function (id) {
        if (!present[id]) {
          jobs.push(fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: { _gift: '1' } }] }),
          }).catch(function () { /* gift out of stock: carry on without it */ }));
        }
      });
      Object.keys(present).forEach(function (id) {
        if (earned.indexOf(parseInt(id, 10)) === -1) {
          jobs.push(fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: present[id].key, quantity: 0 }),
          }).catch(function () {}));
        }
      });

      if (!jobs.length) return Promise.resolve(cart);
      return Promise.all(jobs)
        .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .catch(function () { return cart; });
    }

    function refresh(open, added) {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(reconcileGifts)
        .then(function (cart) { render(cart); if (added) showAdded(); if (open) openCart(); return cart; });
    }

    /* AJAX add: intercept any product add-to-cart form (cards + product page) */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!(form.matches('form[action$="/cart/add"], form.pc-form') || (form.getAttribute('action') || '').indexOf('/cart/add') > -1)) return;
      if (form.querySelector('[data-buy-now]')) { /* buy-now handled separately */ }
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      fetch('/cart/add', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      }).then(function () { return refresh(true, true); })
        .catch(function () { form.submit(); })
        .then(function () { if (btn) btn.disabled = false; });
    });

    /* Header cart icon opens the drawer */
    document.addEventListener('click', function (e) {
      var link = e.target.closest('.cart-link');
      if (link) { e.preventDefault(); refresh(true, false); }
    });

    /* Quantity steppers inside the drawer */
    if (body) {
      body.addEventListener('click', function (e) {
        var step = e.target.closest('[data-line-step], [data-line-remove]');
        if (!step) return;
        var line = step.closest('.cart-line');
        var key = line.getAttribute('data-key');
        var next = 0;
        if (step.hasAttribute('data-line-step')) {
          var cur = parseInt(line.querySelector('[data-line-qty] span').textContent, 10) || 1;
          next = Math.max(0, cur + parseInt(step.getAttribute('data-line-step'), 10));
        }
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: next })
        }).then(function (r) { return r.json(); }).then(reconcileGifts).then(function (cart) { render(cart); });
      });
    }

    /* Populate the badge on load */
    refresh(false, false);
  }

  /* ---------- trade application: compose tags, then native submit ----------
     Native submit keeps Shopify's CAPTCHA/bot protection intact (a background
     fetch would be blocked). We only compose the comma-free tag string from
     the qualifying answers into the hidden contact[tags] field, then let the
     customer form submit normally — Shopify creates the tagged Customer. */
  var tradeForm = document.querySelector('[data-trade-apply]');
  if (tradeForm) {
    tradeForm.addEventListener('submit', function () {
      var v = function (id) { var el = document.getElementById(id); return el ? String(el.value || '').trim() : ''; };
      var clean = function (t) { return t.replace(/,/g, ' ').replace(/\s+/g, ' ').trim(); };
      var tags = ['trade-pending'];
      var sector = v('tf-sector'), spend = v('tf-spend'), needs = v('tf-needs'), phone = v('tf-phone');
      if (sector) tags.push('sector: ' + clean(sector));
      if (spend)  tags.push('spend: ' + clean(spend));
      if (needs)  tags.push('needs: ' + clean(needs));
      if (phone)  tags.push('phone: ' + clean(phone));
      var msg = v('tf-msg');
      if (msg)    tags.push('note: ' + clean(msg).slice(0, 200));
      var hidden = tradeForm.querySelector('[data-trade-tags]');
      if (hidden) hidden.value = tags.join(',');
      /* no preventDefault — the form submits natively with the CAPTCHA token */
    });
  }
})();
